/* eslint-disable no-undef */
import ymaps from 'ymaps'

const apiKey = acfData.map_api_key
const mapCenterString = acfData.map_center
const mapCenter = JSON.parse(mapCenterString)
const placemarkCoordinatesString = acfData.placemark_coordinates
const placemarkCoordinates = JSON.parse(placemarkCoordinatesString)
const polygonImage = acfData.polygon_image
const pinTitle = acfData.pin_title
const pinAddr = acfData.pin_addr

// eslint-disable-next-line no-inner-declarations
async function loadYandexMaps() {
    if (!document.getElementById('map')) {
        return
    }

    try {
        const maps = await ymaps.load(`https://api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=ru_RU`)
        initMap(maps)
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to load Yandex Maps', error)
    }
}

// eslint-disable-next-line no-inner-declarations
function initMap(maps) {
    maps.ready(function () {
        var myMap = new maps.Map('map', {
            center: mapCenter,
            zoom: 16,
            controls: [],
        }, {
            searchControlProvider: 'yandex#search',
        })

        // eslint-disable-next-line max-len
        var polygonLayout = maps.templateLayoutFactory.createClass(`<div class="placemark_layout_container"><div class="polygon-layout"><img class="pin-image" width="279" src="${polygonImage}"><div class="pin-title">${pinTitle}</div><p class="pin-addr">${pinAddr}</p></div></div>`)

        var polygonPlacemark = new maps.Placemark(
            placemarkCoordinates, {
                hintContent: '',
            }, {
                iconLayout: polygonLayout,
                iconShape: {
                    type: 'Polygon',
                },
            },
        )

        myMap.geoObjects.add(polygonPlacemark)
        myMap.behaviors.disable(['scrollZoom'])
    })
}

export default loadYandexMaps
